<template>
    <div>
        <van-nav-bar
                title="发票"
                left-arrow
                class="my-nav"
                :fixed="true"
                @click-left="$router.back(-1)"
        />

        <div class="body">
          <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-search
              class="search-warp"
              v-model="value"
              show-action
              placeholder="请输入单据名称"
              @search="onSearch"
          >
            <template #action>
              <div @click="onSearch">搜索</div>
            </template>
          </van-search>
          <van-tabs v-model="active">
            <van-tab title="标签 1"></van-tab>
            <van-tab title="标签 2"></van-tab>
          </van-tabs>
            <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad"
            >
              <van-cell v-for="item in list" :key="item" :title="item" value="内容" label="描述信息" />
            </van-list>
          </van-pull-refresh>
        </div>
    </div>
</template>

<script>
    import {getBillsInfo} from "../../api/balance";

    export default {
        data() {
            return {
              value: 1,
              active: 2,
                data: [
                  {
                    title:'xxx'
                  }
                ],
              list: [],
              loading: false,
              finished: false,
              refreshing: false,
            };
        },
        mounted() {
        },
        methods: {
          onSearch(){},
          onLoad() {
            // 异步更新数据
            // setTimeout 仅做示例，真实场景中一般为 ajax 请求
            setTimeout(() => {
              for (let i = 0; i < 10; i++) {
                this.list.push(this.list.length + 1);
              }

              // 加载状态结束
              this.loading = false;

              // 数据全部加载完成
              if (this.list.length >= 40) {
                this.finished = true;
              }
            }, 1000);
          },
          onRefresh() {
            this.list=[]
            // 清空列表数据
            this.finished = false;

            // 重新加载数据
            // 将 loading 设置为 true，表示处于加载状态
            this.loading = true;
            this.onLoad();
            this.refreshing=false
          },
        }
    };
</script>

<style lang="less" scoped>
    .body {
        margin: 45px 0;
    }

    .cells {
        padding: 15px;
    }


   .search-warp{
     //background: #eee;
     border-bottom: 1px solid #eee;
   }
    .van-cell {
        color: #333;
    }
</style>
